import { Typography } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import { useMemo, type FC } from 'react';

import { boldMatchedText } from '../../../../../../utils';
import { type SearchPreviewProductProps } from '../../types';
import { ProductInfoLabel } from '../ProductInfoLabel';
import { MAX_VISIBLE_SHADES_COUNT, Shades } from '../Shades';
import { SEARCH_PREVIEW_PRODUCT_PRODUCT_INFO } from './constants';
import { Bottom, Brand, Name, Root } from './styles';

export type ProductInfoProps = Pick<
  SearchPreviewProductProps,
  'name' | 'brand' | 'searchPhrase' | 'shades' | 'code' | 'deal' | 'ppa'
>;

export const ProductInfo: FC<ProductInfoProps> = ({ shades, name, brand, searchPhrase, code, deal, ppa }) => {
  const { getTestId } = useTestId();

  const nameWithSearchPhrase = useMemo(() => boldMatchedText({ searchPhrase, text: name }), [searchPhrase, name]);

  return (
    <Root data-testid={getTestId(`${SEARCH_PREVIEW_PRODUCT_PRODUCT_INFO}-${code}`)}>
      <ProductInfoLabel
        ppa={ppa}
        deal={deal}
        code={code}
      />
      <Brand
        variant="overline"
        color="textSecondary"
        data-testid={`${getTestId('brand')}-${code}`}
      >
        {brand ?? ''}
      </Brand>
      <Name
        color="textPrimary"
        data-testid={`${getTestId('name')}-${code}`}
      >
        {nameWithSearchPhrase}
      </Name>
      <Bottom>
        <Typography
          variant="caption"
          color="textSecondary"
        >
          {code}
        </Typography>
        {shades ? (
          <Shades
            shades={shades}
            maxVisible={MAX_VISIBLE_SHADES_COUNT}
          />
        ) : null}
      </Bottom>
    </Root>
  );
};
